module.exports = __webpack_public_path__ + "assets/img/thumb-EISS-Super-eBook.d1348a4a.png";